export const PROPERTY_TYPE = 'App\\Models\\Property';
export const CONTACT_TYPE = 'App\\Models\\Contact';
